export const calculateCellWidth = (isFixedCell, columnWidth) => {
  return isFixedCell ? `${parseInt(columnWidth)}px` : `${columnWidth}%`
}